module.exports = __webpack_public_path__ + "static/media/Northville-Estates-Constitution-and-By-Laws.1cce7271.pdf";